export default __webpack_public_path__ + "static/media/cercle-shape.f14ae223.png";